export class DeviceParamGatewayV3CronGetGatewayConfigByUid {
    public every: string = '1h';
    public enable: number = 1;
}
